import React from "react";
import { View, Text, Button, TextInput } from "ui";
import { styled } from "styles";
import { Header, Footer, InstallApp } from "components";
import { authMutations } from "api";
import { store } from "store";
import { Actions, State, Selectors } from "../store/reducer";
import { connect } from "react-redux";
import { notify } from "../shared/services/notify";
import { Link } from "react-router-dom";
import { RouteComponentProps } from "react-router";

interface P extends RouteComponentProps{
  isAuthenticated: boolean;
}
class Login extends React.Component<P> {
  public state = {
    username: "",
    password: ""
  };

  public render = () => {
    const { username, password } = this.state;
    return (
      <authMutations.SignInMutation>
        {signIn => (
          <form
            onSubmit={async e => {
              e.preventDefault();
              const { isAuthenticated, history } = this.props;

              // if (isAuthenticated) {
              //   history.push("/app");
              //   return;
              // }

              try {
                const res = await signIn({
                  variables: {
                    userName: username,
                    password
                  }
                });
                if (!res || !res.data) {
                  return;
                }
                store.dispatch(Actions.setToken(res.data.signIn));
              } catch (ex) {}
            }}
          >
            <View
              pl={5}
              pr={5}
              mt={5}
              mb={3}
              flexDirection="column"
              alignItems="center"
            >
              <TextInput
                alignSelf="stretch"
                placeholder="Telefon/ e-mail"
                value={username}
                onChange={e => this.setState({ username: e.target.value })}
                mb={2}
              />
              <TextInput
                placeholder="Parola"
                type="password"
                alignSelf="stretch"
                value={password}
                onChange={e => this.setState({ password: e.target.value })}
              />
              <Forgot
                mt={2}
                fontSize={3}
                as={Link}
                to="/forgot-password"
              >
                Ai uitat parola?
              </Forgot>

              <Button
                p={2}
                mt={4}
                alignSelf="stretch"
                as="button"
                type="submit"
                border="none"
              >
                <Text fontSize={4} fontWeight="bold" color="white">
                  Intra in cont
                </Text>
              </Button>
            </View>
          </form>
        )}
      </authMutations.SignInMutation>
    );
  }
}
export default connect((state: State) => ({
  isAuthenticated: Selectors.isAuthenticated(state)
}))(Login);

const Forgot = styled(Text)`
  text-decoration: underline;
  cursor: pointer;
  color: black;
` as any;



// WEBPACK FOOTER //
// ./src/pages/Login.tsx